import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type { Subject } from './types';

export const getSubjectsList = (): Promise<ListResponseWithPagination<Subject>> => {
  return appApi
    .get('/subjects', {
      params: { size: 2000, sort: ['name,asc'] },
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить предметы' });
      throw error;
    });
};
